export const DEFAULT_DOMAIN_NAME =
  process.env.REACT_APP_TUNNEL_DOMAIN ||
  (process.env.VERCEL_URL ? 'localhost' : document.location.href.match(/\/\/([^:/]+)/)?.[1]);

export const DomainType = {
  LOS: 'LOS',
  POS: 'POS',
  BROKERS_APPLY: 'BrokersApply',
  BROKERS_PORTAL: 'BrokersPortal',
  REALTORS_PORTAL: 'RealtorsPortal',
  SUB_COMPANY: 'SubCompany',
};
